<template>
  <v-card flat class="card-bg rounded-20">
    <v-toolbar dense flat class="transparent">
      <v-toolbar-title class="title-font"> ORDER FORM </v-toolbar-title>
      <v-spacer />
      <span class="text-caption grey--text mr-1">Drag to Order</span>
    </v-toolbar>
    <v-card-text class="pt-0 pb-2">
      Customize your order form. Choose from a number of widgets, mark a
      question as mandatory and input your available responses. Drag and drop a
      question to modify the order.
    </v-card-text>

    <QuestionList
      v-if="questions"
      v-model="questions"
      :loading="loading"
      :validate="validate"
    />

    <v-card-actions class="mx-2">
      <v-btn
        :class="{ 'btn-primary': unsavedChanges }"
        @click="saveProduct"
        text
        :disabled="loading || !unsavedChanges"
      >
        <v-progress-circular
          v-if="saving"
          indeterminate
          size="20"
          class="mr-2"
        />
        <v-icon v-if="!saving" class="mr-2"> mdi-content-save </v-icon>
        Save Changes
      </v-btn>
      <v-btn
        class="rounded-10"
        :color="unsavedChanges ? 'error' : ''"
        @click="revert"
        text
        :disabled="loading || !unsavedChanges"
      >
        <v-icon class="mr-2"> mdi-refresh </v-icon>
        Revert Changes
      </v-btn>
      <v-spacer />
      <v-btn class="btn-primary" @click="addQuestion" :disabled="loading" text>
        Add Question
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import QuestionList from "./ProductForm/QuestionList.vue"
import { deepEqual, deepCopy, deepValid, generateUUID } from "@/utils"
import client from "@/lib/ApiClient"

export default {
  props: ["value", "originals", "initialising"],

  components: { QuestionList },

  data() {
    return {
      saving: false,
      deleting: false,
      previewDialog: false,
      validate: false
    }
  },

  computed: {
    questions: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit("input", value)
      }
    },

    loading() {
      return this.saving || this.deleting || this.initialising
    },

    unsavedChanges() {
      return !deepEqual(this.questions, this.originals, ["uid", "expanded"])
    }
  },

  methods: {
    addQuestion() {
      this.questions.push({
        id: generateUUID(),
        expanded: null,
        name: "",
        description: "",
        widget: "",
        metadata: {
          responses: []
        }
      })
    },

    revert() {
      this.$emit("input", deepCopy(this.originals))
    },

    async saveProduct() {
      const payload = deepCopy(this.questions)
      payload.forEach((q) => {
        if (!["drop_down_picker", "tooth_picker"].includes(q.widget)) {
          delete q.metadata.responses
        }
      })

      if (!deepValid(payload, ["description", "expanded"]))
        return (this.validate = true)
      this.validate = false

      this.saving = true
      const response = await client.instance.orders.createForm(payload)
      response.forEach((q) => {
        q.id = generateUUID()
        this.$set(q, "expanded", null)
      })

      this.$emit("input", response)
      this.$emit("save", response)
      this.saving = false
    }
  }
}
</script>
